import request from '@/utils/request'

export const getTraceTemplateList = ({ page, size, ...params }) => {
  return request({
    url: `/trace/template/info/${page}/${size}`,
    params
  })
}

// 启用/停用：status 1启用 0停用
export const postTraceTemplateStatus = (id, status) => {
  return request({
    method: 'post',
    url: `/trace/template/info/status/${id}/${status}`
  })
}

export const traceQrCode = ({ batchCode, traceCode, params }) => {
  const { uuid, ...restProps } = params
  return request({
    method: 'post',
    url: `/trace/qrcode/check/${batchCode}/${traceCode}`,
    headers: { uuid },
    params: restProps
  })
}

export const postTraceTemplateEdit = (data) => {
  return request({
    method: 'post',
    url: '/trace/template/info',
    data
  })
}

export const putTraceTemplateAdd = (data) => {
  return request({
    method: 'put',
    url: '/trace/template/info',
    data
  })
}

export const getTraceTemplateDetail = (id) => {
  return request({
    url: `/trace/template/info/${id}`
  })
}

export const deleteTraceTemplateDel = (id) => {
  return request({
    method: 'delete',
    url: `/trace/template/info/${id}`
  })
}

export const delTraceTemplateList = (data) => {
  return request({
    method: 'delete',
    url: '/trace/template/info/all',
    data
  })
}

// 产品溯源模板
export const putTraceTemplateProduct = (data) => {
  return request({
    method: 'put',
    url: '/trace/producttemplate',
    data
  })
}

export const getTraceTemplateProduct = (productId) => {
  return request({
    url: `/trace/producttemplate/${productId}`
  })
}

export const deleteTraceTemplateProduct = (id) => {
  return request({
    method: 'delete',
    url: `/trace/producttemplate/${id}`
  })
}
